import { getRequest, postRequest } from "app/axiosClient";
import { showLoader, hideLoader } from "../GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "../ResultNotification/Notification";
import {
  setProductTypes,
  setDepartments,
  setCategories,
  setSalesTax,
  setClients,
  setEmployes,
  setclientAddress,
  setStatus,
  setEmployees,
  setProjectTasks,
  setCompanyNames,
  setSourceOfLeads,
  setPartnerType,
  setWarrantyUnits,
  setAddressProvinces,
  setAddressCountries,
  setLookupData,
  setTotalItems,
  setCompanies,
  setQuoteTypes,
  setServiceIntervals,
  setAddressList,
  setPartners,
  setPartnerSubClients,
  setcompanyTAndC,
  setTechnicians,
  setEmergencyTypes,
  setProjects,
  //setVendors,
} from "./LookupSlice";
import LookupTypeEnum from "features/Enums/LookupTypeEnum";
import { getRolesApi } from "features/Admin/Employees/EmployeesAPI";
import { uploadAttachment } from "CommonComponents/Attachments/AttachmentsAPI";

export const getProductsTypeAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetServiceTypeLookup`)
      .then((res) => {
        dispatch(setProductTypes(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrorproducttypes"
    );
  }
};

export const getDepartmentsAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetDepartmentLookup`)
      .then((res) => {
        dispatch(setDepartments(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unabletoretrievedepartments"
    );
  }
};

export const getCategoriesAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetCategoryLookup`)
      .then((res) => {
        dispatch(setCategories(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpedtederrorcategories"
    );
  }
};

export const getSalesTaxAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetSalesTaxLookup`)
      .then((res) => {
        dispatch(setSalesTax(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpedtederrorsalestax"
    );
  }
};

export const getClientAPI =
  (searchQuery = "") =>
  (dispatch) => {
    try {
      dispatch(showLoader());
      getRequest(
        `api/Lookup/GetClientsLookup${
          searchQuery ? `?searchQuery=${searchQuery}` : ""
        }`
      )
        .then((res) => {
          dispatch(setClients(res?.data));
          dispatch(hideLoader());
        })
        .catch((e) => {
          const errorMessage = e?.response?.data?.Message || e?.message;
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Lookup.Notification.Unexpectederror",
            errorMessage,
            "Lookup.Notification.Pleasetryagainlater"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Lookup.Notification.Unexpectederror",
        "",
        "Lookup.Notification.Unexpectederrorcustomers"
      );
    }
  };

export const getEmployeeAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest("api/Lookup/GetDesignatedEmpLookup")
      .then((res) => {
        dispatch(setEmployes(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederroremployee"
    );
  }
};

export const getClientAddressAPI = (id) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetClientAddressLookup?clientId=${id}`)
      .then((res) => {
        dispatch(setclientAddress(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrorcustomeraddress"
    );
  }
};
export const getStatusAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest("api/Lookup/GetStatusLookup")
      .then((res) => {
        dispatch(setStatus(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrorretrievingroles"
    );
  }
};

export const addIntoLookupTableAPI = (values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest("api/Lookup/InsertDataIntoLookup", values)
      .then((res) => {
        switch (res?.data) {
          case LookupTypeEnum.Department:
            dispatch(getDepartmentsAPI());
            break;
          case LookupTypeEnum.Type:
            dispatch(getProductsTypeAPI());
            break;
          case LookupTypeEnum.Category:
            dispatch(getCategoriesAPI());
            break;
          case LookupTypeEnum.SalesTax:
            dispatch(getSalesTaxAPI());
            break;
          case LookupTypeEnum.Status:
            dispatch(getStatusAPI());
            break;
          case LookupTypeEnum.WarrantyUnit:
            dispatch(getWarrantyUnitsAPI());
            break;
          case LookupTypeEnum.Roles:
            dispatch(getRolesApi());
            break;
          case LookupTypeEnum.AddressProvince:
            dispatch(getAddressProvincesAPI());
            break;
          case LookupTypeEnum.AddressCountry:
            dispatch(getAddressCountriesAPI());
            break;
          case LookupTypeEnum.QuoteType:
            dispatch(getQuoteTypeAPI());
            break;
          case LookupTypeEnum.ServiceInterval:
            dispatch(getServiceIntervalAPI());
            break;
          default:
            console.log("Unknown Lookup Type:", res?.data);
            break;
        }
        OpenNotificationWithIcon(
          "success",
          "Lookup.Notification.Recordadded",
          "",
          "Lookup.Notification.Newrecordadded"
        );
        dispatch(hideLoader());
        return res?.data;
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederroraddingrecords"
    );
  }
};
export const updateLookupTableAPI = (values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest("api/Lookup/UpdateLookup", values)
      .then((res) => {
        switch (res?.data) {
          case LookupTypeEnum.Department:
            dispatch(getDepartmentsAPI());
            break;
          case LookupTypeEnum.Type:
            dispatch(getProductsTypeAPI());
            break;
          case LookupTypeEnum.Category:
            dispatch(getCategoriesAPI());
            break;
          case LookupTypeEnum.SalesTax:
            dispatch(getSalesTaxAPI());
            break;
          case LookupTypeEnum.Status:
            dispatch(getStatusAPI());
            break;
          case LookupTypeEnum.WarrantyUnit:
            dispatch(getWarrantyUnitsAPI());
            break;
          case LookupTypeEnum.Roles:
            dispatch(getRolesApi());
            break;
          case LookupTypeEnum.AddressProvince:
            dispatch(getAddressProvincesAPI());
            break;
          case LookupTypeEnum.AddressCountry:
            dispatch(getAddressCountriesAPI());
            break;
          case LookupTypeEnum.QuoteType:
            dispatch(getQuoteTypeAPI());
            break;
          case LookupTypeEnum.ServiceInterval:
            dispatch(getServiceIntervalAPI());
            break;
          default:
            console.log("Unknown Lookup Type:", res?.data);
            break;
        }
        OpenNotificationWithIcon(
          "success",
          "Lookup.Notification.Recordupdated",
          "",
          "Lookup.Notification.Recordupdatedsuccessfully"
        );
        dispatch(hideLoader());
        return res?.data;
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
        throw e;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrorupdatingrecords"
    );
    throw e;
  }
};
export const deleteLookupAPI = (lookupType, id) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(
      `api/Lookup/DeleteLookup?lookupType=${lookupType}&id=${id}`
    )
      .then((res) => {
        switch (lookupType) {
          case LookupTypeEnum.Department:
            dispatch(getDepartmentsAPI());
            break;
          case LookupTypeEnum.Type:
            dispatch(getProductsTypeAPI());
            break;
          case LookupTypeEnum.Category:
            dispatch(getCategoriesAPI());
            break;
          case LookupTypeEnum.SalesTax:
            dispatch(getSalesTaxAPI());
            break;
          case LookupTypeEnum.Status:
            dispatch(getStatusAPI());
            break;
          case LookupTypeEnum.WarrantyUnit:
            dispatch(getWarrantyUnitsAPI());
            break;
          case LookupTypeEnum.Roles:
            dispatch(getRolesApi());
            break;
          case LookupTypeEnum.AddressProvince:
            dispatch(getAddressProvincesAPI());
            break;
          case LookupTypeEnum.AddressCountry:
            dispatch(getAddressCountriesAPI());
            break;
          case LookupTypeEnum.QuoteType:
            dispatch(getQuoteTypeAPI());
            break;
          case LookupTypeEnum.ServiceInterval:
            dispatch(getServiceIntervalAPI());
            break;
          default:
            break;
        }
        OpenNotificationWithIcon(
          "success",
          "Lookup.Notification.Recorddeleted",
          "",
          "Lookup.Notification.RecorddeletedSuccessfully"
        );
        dispatch(hideLoader());
        return res?.data;
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
        throw e;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrordeletingrecords"
    );
    throw e;
  }
};
export const getEmployeesAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetEmployeeLookup`)
      .then((res) => {
        dispatch(setEmployees(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederroremployee"
    );
  }
};

export const getProjectTasksAPI = (ProjectId) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetProjectTasksLookup/${ProjectId}`)
      .then((res) => {
        dispatch(setProjectTasks(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrorprojecttasks"
    );
  }
};

// export const getVendorsAPI = () => (dispatch) => {
//   try {
//     dispatch(showLoader());
//     getRequest(`api/Lookup/GetVendorsLookup`)
//       .then((res) => {
//         dispatch(setVendors(res?.data));
//         dispatch(hideLoader());
//       })
//       .catch((e) => {
//         dispatch(hideLoader());
//       });
//   } catch (e) {
//     dispatch(hideLoader());
//     OpenNotificationWithIcon(
//       "error",
//       "Erreur inattendue",
//       "Une erreur inattendue s'est produite lors de la récupération des tâches du projet."
//     );
//   }
// };

export const getcompaniesAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetCompaniesLookup`)
      .then((res) => {
        dispatch(setCompanyNames(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Erreur inattendue",
          `${errorMessage} Veuillez réessayer plus tard.`
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Erreur inattendue",
      "Une erreur inattendue s'est produite lors de la récupération de l'employé. Veuillez réessayer."
    );
  }
};

export const getSourceOfLeadsAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetSourceOfLeadLookup`)
      .then((res) => {
        dispatch(setSourceOfLeads(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederroremployee"
    );
  }
};

export const getPartnerTypeAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetPartnerTypeLookup`)
      .then((res) => {
        dispatch(setPartnerType(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Erreur inattendue",
          `${errorMessage} Veuillez réessayer plus tard.`
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Erreur inattendue",
      "Une erreur inattendue s'est produite lors de la récupération de l'employé. Veuillez réessayer."
    );
  }
};
export const getWarrantyUnitsAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetWarrantyUnitLookup`)
      .then((res) => {
        dispatch(setWarrantyUnits(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrorwarrantyunits"
    );
  }
};

export const getAddressProvincesAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetAddressProvinceLookup`)
      .then((res) => {
        dispatch(setAddressProvinces(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Erreur inattendue",
          `${errorMessage} Veuillez réessayer plus tard.`
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Erreur inattendue",
      "Une erreur inattendue s'est produite lors de la récupération de l'employé. Veuillez réessayer."
    );
  }
};

export const getAddressCountriesAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetAddressCountryLookup`)
      .then((res) => {
        dispatch(setAddressCountries(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Erreur inattendue",
          `${errorMessage} Veuillez réessayer plus tard.`
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Erreur inattendue",
      "Une erreur inattendue s'est produite lors de la récupération de l'employé. Veuillez réessayer."
    );
  }
};

export const GetLookupListApi = (lookupType, values) => async (dispatch) => {
  try {
    dispatch(showLoader());
    const res = await postRequest(
      `api/Lookup/GetLookupList?lookupType=${lookupType}`,
      values
    );
    const data = res?.data?.items ?? [];
    const totalItems = res?.data?.totalItems ?? res?.data?.TotalItems ?? 0;

    dispatch(setLookupData({ lookupType, items: data }));
    dispatch(setTotalItems({ lookupType, total: totalItems }));

    dispatch(hideLoader());
  } catch (error) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Lookup.Notification.Anunexpectederroroccurred"
    );
  }
};
export const getCompanyListAPI = (values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lookup/GetCompanyList`, values)
      .then((res) => {
        dispatch(setCompanies(res.data));
        dispatch(hideLoader());
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "MappedCompany.Notification.Errorwhilefetchingmappedcompanies"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "MappedCompany.Notification.UnexpectedErrorWhileFetchingMappedCompanies"
    );
    return false;
  }
};

export const addCompanyAPI = (companyData) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lookup/AddCompanyInfo`, companyData).then((res) => {
      dispatch(uploadAttachment(res?.data));
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "success",
        "MappedCompany.CompanyAdded",
        "",
        "MappedCompany.Notification.MappedCompanyAddedSuccessfully"
      );
      return { id: res?.data };
    });
  } catch (e) {
    const errorMessage = e?.response?.data?.Message || e?.message;
    dispatch(hideLoader());
    OpenNotificationWithIcon("error", "Common.Error", errorMessage);
    return { id: null };
  }
};
export const updateCompanyAPI = (companyData) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lookup/UpdateCompanyInfo`, companyData)
      .then((res) => {
        dispatch(uploadAttachment(res?.data));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "MappedCompany.CompanyUpdated",
          "",
          "MappedCompany.Notification.MappedCompanyUpdatedSuccessfully"
        );
        return { id: res?.data };
      })
      .catch((e) => {
        const errorMessage = e?.response?.data || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", errorMessage);
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      e?.response?.data || "",
      "MappedCompany.Notification.Anunexpectederroroccurredwhileupdating"
    );
    return { id: null };
  }
};

export const getQuoteTypeAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetQuoteTypeLookup`)
      .then((res) => {
        dispatch(setQuoteTypes(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Erreur inattendue",
          `${errorMessage} Veuillez réessayer plus tard.`
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Erreur inattendue",
      "Une erreur inattendue s'est produite lors de la récupération de l'employé. Veuillez réessayer."
    );
  }
};

export const getServiceIntervalAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetServiceIntervalLookup`)
      .then((res) => {
        dispatch(setServiceIntervals(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Erreur inattendue",
          `${errorMessage} Veuillez réessayer plus tard.`
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Erreur inattendue",
      "Une erreur inattendue s'est produite lors de la récupération de l'employé. Veuillez réessayer."
    );
  }
};

export const getAddressListAPI = (values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lookup/GetAddressLookup`, values)
      .then((res) => {
        dispatch(setAddressList(res.data));
        dispatch(hideLoader());
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Lookup.Notification.ErrorwhilefetchingAddress"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Lookup.Notification.UnexpectederrorAddress"
    );
    return false;
  }
};

export const GetPartnersApi = (searchQuery) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetPartnersLookup?searchQuery=${searchQuery}`)
      .then((res) => {
        dispatch(setPartners(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Clients.Notification.UnexpectedError",
      "",
      "PartnerCLient.Notification.Anunexpectederroroccurred"
    );
  }
};

export const GetPartnerSubClientsApi =
  (partnerId, searchQuery) => (dispatch) => {
    try {
      dispatch(showLoader());
      getRequest(
        `api/Lookup/GetPartnersSubClientsLookup?partnerId=${partnerId}&searchQuery=${searchQuery}`
      )
        .then((res) => {
          dispatch(setPartnerSubClients(res?.data));
          dispatch(hideLoader());
        })
        .catch((e) => {
          const errorMessage = e?.response?.data?.Message || e?.message;
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Lookup.Notification.Unexpectederror",
            errorMessage,
            "Lookup.Notification.Pleasetryagainlater"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Clients.Notification.UnexpectedError",
        "",
        "PartnerCLient.Notification.Anunexpectederroroccurred"
      );
    }
  };

export const getCompanyTAndCAPI = (token) => (dispatch) => {
  try {
    dispatch(showLoader());
    return getRequest(`api/Lookup/GetCompanyTAndCLookup?token=${token}`)
      .then((res) => {
        dispatch(setcompanyTAndC(res.data));
        dispatch(hideLoader());
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "MappedCompany.Notification.Errorwhilefetchingmappedcompanies"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "MappedCompany.Notification.UnexpectedErrorWhileFetchingMappedCompanies"
    );
    return false;
  }
};

export const getTechniciansAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetTechniciansLookup`)
      .then((res) => {
        dispatch(setTechnicians(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederroremployee"
    );
  }
};

export const getEmergencyTypeAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetEmergencyTypeLookup`)
      .then((res) => {
        dispatch(setEmergencyTypes(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Erreur inattendue",
          `${errorMessage} Veuillez réessayer plus tard.`
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Erreur inattendue",
      "Une erreur inattendue s'est produite lors de la récupération de l'employé. Veuillez réessayer."
    );
  }
};
export const getProjectsBySubClientAPI =
  (subClientId, companyId, searchQuery = "") =>
  (dispatch) => {
    try {
      dispatch(showLoader());
      getRequest(
        `api/Lookup/GetProjectsBySubClient?subClientId=${subClientId}&companyId=${companyId}${
          searchQuery ? `&searchQuery=${searchQuery}` : ""
        }`
      )
        .then((res) => {
          dispatch(setProjects(res?.data));
          dispatch(hideLoader());
        })
        .catch((e) => {
          const errorMessage = e?.response?.data?.Message || e?.message;
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Lookup.Notification.Unexpectederror",
            errorMessage,
            "Lookup.Notification.Pleasetryagainlater"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Lookup.Notification.Unexpectederror",
        "",
        "Lookup.Notification.Unexpectederrorprojects"
      );
    }
  };
